import React, { useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SectionContainer, SectionContainerWrapper } from "../../../library/utilities/SectionContainer";
import styled, { ThemeContext } from "styled-components";
import { ButtonQuizLinkThemed, ButtonQuizThemed } from "../../../library/symbols/quizButtons";
import { breakpointRuleTablet } from "../../../library/utilities/variables";
const QuestionContainer = styled(SectionContainer) `
    overflow: hidden;
`;
const QuestionWrapper = styled(SectionContainerWrapper) `
    display: flex;
    flex-direction: column;
    align-items: stretch;

    padding-top: 52px;
    min-height: calc(100vh - 48px);

    @media (${breakpointRuleTablet}) {
        padding-top: 15vh;
        min-height: calc(100vh - 88px);
    }
`;
const QuestionTitle = styled(motion.h2) `
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: -1px;
    text-align: center;

    margin-bottom: 36px;

    @media (${breakpointRuleTablet}) {
        //styleName: Desktop/Headlines/H4 - 32pt Bold;
        font-size: 32px;
        line-height: 36px;
        max-width: 584px;
        margin-right: auto;
        margin-left: auto;

        margin-bottom: 52px;
    }
`;
const QuestionList = styled.ul `
    width: 100%;
    max-width: 378px;
    margin: 0 auto;
`;
const QuestionListItem = styled(motion.li) `
    margin-bottom: 20px;
`;
const QuestionCharacter = styled(motion.img) `
    display: inline-block;
    position: relative;
    line-height: 0;
    width: 186px;
    height: auto;

    transition: all 500ms ease-in-out;


    @media (${breakpointRuleTablet}) {
        width: 400px;
    }
`;
const QuestionCharacterContainer = styled(motion.div) `
    overflow: hidden;
    margin-top: auto;
    line-height: 0;
    align-self: flex-start;

    transition: all 400ms ease-in-out;

    &.start {
        margin-left: -45px;
    }

    &.middle {
        margin-left: calc(50% - ${186 / 2}px)
    }

    &.end {
        margin-left: calc(100% - 150px);
    }


    @media (${breakpointRuleTablet}) {
        &.start {
            margin-left: 35px;
        }

        &.middle {
            margin-left: calc(50% - ${400 / 2}px)
        }

        &.end {
            margin-left: calc(100% - 481px);
        }
    }
`;
export function Question({ question, onAnswered, characterPosition }) {
    const currentTheme = useContext(ThemeContext);
    return (React.createElement(QuestionContainer, { animate: { opacity: 1 }, exit: { opacity: 1 } },
        React.createElement(QuestionWrapper, null,
            React.createElement(QuestionTitle, { key: question.id, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, question.question),
            React.createElement(QuestionList, null, question.options.map((option) => (React.createElement(QuestionListItem, { key: option.id, initial: { opacity: 0 }, animate: { opacity: 1 } },
                option.node_type === 'link' &&
                    React.createElement(ButtonQuizLinkThemed, { href: option.url, target: "_self" }, option.cta_title),
                option.node_type !== 'link' &&
                    React.createElement(ButtonQuizThemed, { onClick: () => onAnswered(option) }, option.cta_title))))),
            React.createElement(AnimatePresence, null,
                React.createElement(QuestionCharacterContainer, { className: characterPosition },
                    React.createElement(QuestionCharacter, { className: characterPosition, key: characterPosition, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: .2, type: 'easeInOut' }, src: currentTheme.character[characterPosition] }))))));
}
